import accounting from 'accounting'
import bytes from 'bytes'
import moment from 'moment'

export default {
  methods: {
    isEmpty(list) {
      return (list || []).length === 0
    },

    isNotEmpty(list) {
      return !this.isEmpty(list)
    },

    formatDate(date) {
      return date === null ? '' : moment(date).format('MMMM Do YYYY, h:mm:ss a')
    },

    formatMoney(money, precision = 2) {
      const formattedMoney = (money || 0) / 100

      return accounting.formatMoney(formattedMoney, { precision: precision })
    },

    formatNumber(number, precision = 0) {
      return accounting.formatNumber(number, { precision: precision })
    },

    formatSize(number) {
      return bytes(number)
    }
  }
}
